import script from "./CommentCount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentCount.vue?vue&type=script&lang=js"
export * from "./CommentCount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/CommentCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c651325e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c651325e', __exports__)) {
    api.reload('c651325e', __exports__)
  }
  
}


export default __exports__